var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIconIo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 527.17 497.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #8b9635;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.55,492.92c-16.59,0-30.04-13.45-30.04-30.04v-193.62c0-16.59,13.45-30.04,30.04-30.04s30.04,13.44,30.04,30.04v193.62c0,16.59-13.45,30.04-30.04,30.04"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.84,152.98c0,29.41-23.84,53.25-53.25,53.25s-53.25-23.84-53.25-53.25,23.84-53.25,53.25-53.25,53.25,23.84,53.25,53.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M449.95,46.28c-16.67-16.67-35.19-30.81-55.09-42.25-14.21-8.17-32.37-3.31-40.74,10.78h0c-8.64,14.54-3.46,33.1,11.17,41.57,14.24,8.24,30.22,21.36,42.33,33.08,0,0-.98-.98,0,0,37.11,37.12,56.86,85.12,59.27,133.82.14,3.13.23,6.28.23,9.44,0,54.38-21.18,105.5-59.63,143.95-1.24,1.24-2.31,2.57-3.29,3.95-38.04,36.35-87.73,56.37-140.53,56.37s-103.27-20.32-141.42-57.22c-.81-1.07-1.68-2.12-2.66-3.09-37.11-37.12-56.86-85.12-59.27-133.82-.14-3.14-.23-6.28-.23-9.44,0-54.38,21.18-105.5,59.63-143.95,1.24-1.24,0,0,0,0,11.88-11.36,28.2-25.05,42.1-33.1,14.65-8.48,19.87-27.05,11.22-41.6h0c-8.37-14.09-26.53-18.94-40.73-10.78-19.94,11.46-38.5,25.61-55.2,42.31C25.61,97.77-.08,165.43,0,233.06c0,.11,0,.23,0,.34,0,70.43,27.43,136.63,77.23,186.43,54.74,54.74,129.31,82.44,207.52,76.4,52.16-4.03,102.26-23.77,143.08-56.48,66.33-53.15,99.44-129.95,99.34-206.7,0-.11,0-.23,0-.34,0-70.42-27.43-136.63-77.23-186.43Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIconIo);
export default __webpack_public_path__ + "static/media/logo-icon-io.46d3656d7202400437191f17250166ca.svg";
export { ForwardRef as ReactComponent };